import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { BatchHttpLink } from 'apollo-link-batch-http';
import fetch from 'node-fetch';
// import { ApolloLink } from 'apollo-link';
// import { uncrunch } from 'graphql-crunch';
import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory';
import { CachePersistor } from 'apollo-cache-persist';
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client';
import Auth from 'Lib/auth';
import { isProd } from 'Lib/utils';
import CustomHeuristicFragmentMatcher from 'Lib/customFragmentMatcher';

// Install the vue plugin
Vue.use(VueApollo);

function getAuth() {
  const user = Auth.getUser();
  const clientId = user && user.pool ? user.pool.getClientId() : '';
  const username = user ? user.username : '';
  const keyPrefix = `CognitoIdentityServiceProvider.${clientId}.${username}`;
  const idTokenKey = `${keyPrefix}.idToken`;
  return localStorage.getItem(idTokenKey);
}

const cache = new InMemoryCache({
  dataIdFromObject: (result) => {
    switch (result.__typename) {
      case 'Chart': return result.__typename && result._key ? `${result.__typename}:${result._key}:${Math.floor(Date.now() / 300000)}` : defaultDataIdFromObject(result);
      default: return result.__typename && result._key ? `${result.__typename}:${result._key}:${Math.floor(Date.now() / 1200000)}` : defaultDataIdFromObject(result);
    }
  },
  fragmentMatcher: new CustomHeuristicFragmentMatcher(),
});

export const cachePersistor = new CachePersistor({
  cache,
  storage: window.localStorage,
  // trigger: isProd(),
  debug: !isProd(),
});

const httpLink = new BatchHttpLink({ uri: process.env.VUE_APP_GRAPHQL_HTTP, batchMax: 1, fetch });


// const middlewareLink = new ApolloLink((operation, forward) =>
//   forward(operation)
//     .map(response =>
//       // response.data = uncrunch(response.data);
//       response));

// const myLink = ApolloLink.from[(middlewareLink, httpLink)];

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  httpEndpoint: process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql',
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  // wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:4000/graphql',
  wsEndpoint: null,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  defaultHttpLink: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,

  // Override default http link
  link: httpLink,

  // Override default cache
  cache,

  // Override the way the Authorization header is set
  getAuth,

  // Additional ApolloClient options
  // apollo: { ... }

  // Client local data (see apollo-link-state)
  // clientState: { resolvers: { ... }, defaults: { ... } }
  watchQuery: {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
  mutate: {
    errorPolicy: 'all',
  },
};

// Call this in the Vue app file
export default function createProvider(options = { partialRefetch: true }) {
  // Create apollo client
  const { apolloClient, wsClient } = createApolloClient({
    ...defaultOptions,
    ...options,
  });
  apolloClient.wsClient = wsClient;

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'ignore',
      },
      query: {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
      },
      mutate: {
        errorPolicy: 'all',
      },
    },
    errorHandler(error) {
      // eslint-disable-next-line no-console
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message);
    },
  });

  apolloProvider.login = async () => {
    if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
    try {
      await apolloClient.resetStore();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('%cError on cache reset (login)', 'color: orange;', e.message);
    }
  };

  apolloProvider.logout = async () => {
    if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
    try {
      await apolloClient.resetStore();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('%cError on cache reset (logout)', 'color: orange;', e.message);
    }
  };

  apolloProvider.cleanStore = async () => {
    if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
    try {
      await apolloClient.clearStore();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('%cError on cache reset (login)', 'color: orange;', e.message);
    }
  };


  return apolloProvider;
}
